import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener('click', this.boundClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.boundClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    // Close all other dock dropdowns first
    document.querySelectorAll('.dock-dropdown').forEach(dropdown => {
      if (dropdown !== this.menuTarget) {
        dropdown.classList.add('hidden')
      }
    })

    this.menuTarget.classList.toggle('hidden')
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add('hidden')
    }
  }
}
